// extracted by mini-css-extract-plugin
module.exports = {"inputStyles":"inputStyles---9DN0"};